module.exports = __webpack_public_path__ + "static/media/north-korea.bb9ff242.png";